<template>
    <div class="pa-0 ma-0">
        <!--Parte visible del componente-->
        <tr>
            <td style="width:80px !important; padding-right:4px !important;">
                <div >
                    <v-checkbox class="mb-5" primary hide-details :value="item.empleado_id" v-model="selected_general" @click="selectEmployee(item.empleado_id)"></v-checkbox>
                </div>
            </td> 
            <td style="padding-left:16px !important;"> 
                <div>
                    Q01 / P001
                </div>
            </td>
            <td>
                <div>
                    01/05/21
                </div>
            </td>
            <td>
                <div>
                    STP
                </div>
            </td>
            <td style="">
                <div class="tblOpciones">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-btn v-if="item.contratos[0].contrato_estatus_id != 2" v-on="on" class="botonHover" icon fab dark small @click="abrirModalPDF(item.contratos[0])">
                            <v-icon class="tamIconoBoton invertirColorBotones">remove_red_eye</v-icon>
                        </v-btn>
                        </template>
                        <span>Previsualizar</span>
                    </v-tooltip>
                    <v-tooltip bottom> 
                        <template v-slot:activator="{ on }">
                        <v-btn v-if="item.contratos[0].contrato_estatus_id != 2" v-on="on" class="botonHover" icon fab dark small @click="descargar(item.contratos[0])">
                            <v-icon
                                v-text="'$get_app_outline'"
                                class="iconoDelgadoBoton"
                            ></v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class=" botonHover" icon fab dark small @click="abrirModalCargaDocumento(item,item.contratos[0].id)">
                            <v-icon class="tamIconoBoton invertirColorBotones" >cloud_upload</v-icon>
                        </v-btn>
                        </template>
                        <span>Subir contrato firmado</span>
                    </v-tooltip>
                </div>
            </td>
            <td style="min-width:70px!important; max-width:81px!important; width:80px; padding-left:8px;">
                <div class="tblOpciones" >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon fab dark small @click="isOpen ? isOpen = false:isOpen = true">
                            <v-icon class="tamIconoBoton iconoDelgadoBoton">{{isOpen ? 'keyboard_arrow_up':'keyboard_arrow_down'}}</v-icon>
                        </v-btn>
                        </template>
                        <span>Desplegar</span>
                    </v-tooltip>
                </div>
            </td>
        </tr>
        <!--Parte desplegable del componente-->
        <template v-if="isOpen">
            <tr style="background:#FAFBFF !important;">
                <td style="width:80px !important;"></td>
                <td style="padding-left:16px !important;">
                    Empleado
                </td>
                <td>Estatus</td>
                <td  style="min-width:70px!important; max-width:81px!important; width:80px; padding-left:8px;"></td>
            </tr>
            <tr :key="contrato.id" v-for="contrato in data"  class="td-short">
                <td style="width:80px !important;">
                </td>
                <td style="padding-left:6px !important;">
                    <div>
                        <v-list class="py-0 my-0" style="background:transparent;">
                            <v-list-item class="py-0 my-0 px-0">
                                <v-list-item-avatar class="py-0 my-0">
                                    <v-img class="py-0 my-0" :src="urlImg+item.foto"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content class="ml-0 py-0 my-0">
                                    <v-list-item-title class="tblPrincipal">{{ item.nombre_completo }}</v-list-item-title>
                                    <v-list-item-title class="tblSecundario text-mute">{{/* rol=="root"?item.empleado.cliente.nombre:rol=="admin"?item.empleado.empresa.nombre:item.empleado.sucursal.nombre*/}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </div>
                </td>
                <td></td>
                <td>
                    <div>
                    <p v-if="item.contratos[0].contrato_estatus_id == 1" class="listo mb-0 text-center">{{item.contratos[0].estatus}}</p> 
                    <v-tooltip bottom >
                        <template v-slot:activator="{ on }">
                            <p v-on="on" v-if="item.contratos[0].contrato_estatus_id == 2" class="incompleto mb-0 text-center">{{item.contratos[0].estatus}}</p>
                        </template>
                        <span>{{item.contratos[0].observaciones}}</span>
                    </v-tooltip>
                    <p v-if="item.contratos[0].contrato_estatus_id == 3" class="firmado mb-0 text-center">{{item.contratos[0].estatus}}</p>
                    <p v-if="item.contratos[0].contrato_estatus_id == 4" class="renovar mb-0 text-center">{{item.contratos[0].estatus}}</p>
                    <p v-if="item.contratos[0].contrato_estatus_id == 5" class="vencido mb-0 text-center">{{item.contratos[0].estatus}}</p>
                    <p v-if="item.contratos[0].contrato_estatus_id == 6" class="cancelado mb-0 text-center">{{item.contratos[0].estatus}}</p>
                </div>
                </td>
                <td>
                    <div class="tblOpciones">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <v-btn v-if="item.contratos[0].contrato_estatus_id != 2" v-on="on" class="botonHover" icon fab dark small @click="abrirModalPDF(contrato)">
                                <v-icon class="tamIconoBoton invertirColorBotones">remove_red_eye</v-icon>
                            </v-btn>
                            </template>
                            <span>Previsualizar</span>
                        </v-tooltip>
                        <v-tooltip bottom >
                            <template v-slot:activator="{ on }">
                            <v-btn v-if="item.contratos[0].contrato_estatus_id != 2" v-on="on" class=" botonHover" icon fab dark small @click="descargar(contrato)">
                                <v-icon
                                    v-text="'$get_app_outline'"
                                    class="iconoDelgadoBoton"
                                ></v-icon>
                            </v-btn>
                            </template>
                            <span>Descargar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class=" botonHover" icon fab dark small @click="abrirModalCargaDocumento(item,contrato.id)">
                                <v-icon class="tamIconoBoton invertirColorBotones" >cloud_upload</v-icon>
                            </v-btn>
                            </template>
                            <span>Subir contrato firmado</span>
                        </v-tooltip>
                    </div>
                </td>
                <td  style="min-width:70px!important; max-width:81px!important; width:80px; padding-left:8px;"></td>
            </tr>
        </template>
    </div>
</template>


<script>

//IMPORT

//PLUGINS

import GetUrlImg from "@/plugins/Urlimagen";

export default {
    name: 'expandable-item',

    //PORPS item Objeto contrato{}
    props: {
        item: {
            type: Object,
            required: true,
            default: ''
        },
        data: {
            type: Array,
            required: true,
            default: []
        },
        selected_general: {
            type: Array,
            required: true,
            default: ''
        },
    },
    data() {
        return {
            isOpen: false,
            urlImg : '',
        }
    },
    //COMPUTED

    /*
    Entrada:
    Salida:
    Descripcion: Las funciones de este tipo se tratan como variables 
                 reactivas y sirven para que la misma variable haga 
                 una funcion para formatar los datos y regresar un 
                 nuevo valor en vez de crear funciones noramles y 
                 tener que llamarlas. Estas apenas se asignen se ejecutaran 
                 y ellas mismas regrsaran el nuevo resultado.
    */
    computed: {
        /*
        Entrada: 
        Salida: contratos Array de Objetos contratos[{},{}]
        Descripcion: Regresa la lista de contratos hijos y padre de un 
                     empleado siendo el primer elemento el padre y los 
                     sobrantes el hijo ya que la vraiable todos los 
                     contratos estan en un mismo nivel.
        */
        contratos(){
            let contratos = JSON.parse(JSON.stringify(this.item.contratos));
            contratos.shift();
            return contratos;
        }
    },
    methods: {

        //FUNCIONES GENERALES

        /*
        Entrada: data Objeto contrato{}
        Salida: 
        Descripcion: Ejecuta la funcion abrirModalPDF() del lado del 
                     componente padre por medio de un $emit enviando 
                     los parametros que recibe.
        */
        selectEmployee(id){
            this.$emit("selectEmployee",id);
        },

        /*
        Entrada: data Objeto contrato{}
        Salida: 
        Descripcion: Ejecuta la funcion abrirModalPDF() del lado del 
                     componente padre por medio de un $emit enviando 
                     los parametros que recibe.
        */
        abrirModalPDF(data){
            this.$emit("abrirModalPDF",data);
        },

        /*
        Entrada: data Objeto contrato{}
        Salida: 
        Descripcion: Ejecuta la funcion descargar() del lado del 
                     componente padre por medio de un $emit enviando 
                     los parametros que recibe.
        */
        descargar(data){
            this.$emit("descargar",data);
        },

        /*
        Entrada: data Objeto contrato{}
        Salida: 
        Descripcion: Ejecuta la funcion abrirModalRenovar del lado del 
                     componente padre por medio de un $emit enviando 
                     los parametros que recibe.
        */
        abrirModalRenovar(data){
            this.$emit("abrirModalRenovar",data);
        },

        /*
        Entrada: data Objeto contrato{} padre, id del contrato
        Salida: 
        Descripcion: Ejecuta la funcion abrirModalCargaDocumento del lado del 
                     componente padre por medio de un $emit enviando 
                     los parametros que recibe.
        */
        abrirModalCargaDocumento(data,id){
            this.$emit("abrirModalCargaDocumento",{data:data,id:id});
        }
    },
    //MOUNTED se ejecutan instrucciones una vez se crea el componente;
    mounted () {
        /*
        Entrada:
        Salida:
        Descripcion: Ejectua la funcion getURL que trae la url base de las imagenes.
        */
        this.urlImg = GetUrlImg.getURL();
    },
}
</script>

<style scoped>
    /**
    * TRANSITION EFFECT
    */
    .slide-enter-active,
    .slide-leave-active {
        transition-duration: 0.8s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .slide-enter,
    .slide-leave-active {
    opacity: 0
    }

    /*STATUS*/
    .renovar{
        border: solid 0.5px #f7e6c3 !important;
        color: #E19117;
        padding:11px 0px;
        border-radius: 8px;
        width: 175px;
    }
    .incompleto{
        border: solid 0.5px #ffc9cc !important;
        color: #F03738;
        padding:11px 0px;
        border-radius: 8px;
        width: 100px;
    }
    
    .vencido{
        border: solid 0.5px #828282 !important;
        color: #828282;
        padding:11px 0px;
        border-radius: 8px;
        width: 91px;
    }
    .firmado{
        border: solid 0.5px #c5f7cd !important;
        color: #3CC13B;
        padding:11px 0px;
        border-radius: 8px;
        width: 80px;
    }
    .listo{
        border: solid 0.5px #ccd3e2 !important;
        color: #325687;
        padding:11px 0px;
        border-radius: 8px;
        width: 135px;
    }

    /*TABLE*/
    /*
    .filter-asc {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid white;
        margin-bottom: 1px;
    }
    .filter-desc {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid white;
        margin-top: 1px;
    } 
    .active-filter-asc {
        border-bottom: 5px solid #ccc;
    }
    .active-filter-desc {
        border-top: 5px solid #ccc;
    }
    */
    .filter {
        color: #96999a;
        cursor: pointer;
    }
    .inline-block {
        display: inline-block;
    }
    /*
    .table-header-sorting {
        cursor: pointer;
    }*/
    table {
        border-collapse: collapse;
        width: 100%;
        /* white-space: nowrap; */
        overflow-x: scroll;
        /* overflow-y: scroll; */
    }
    th{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: left;
        color: #828282;
        background-color: #f6f5f6;
        padding: 13px 45px 13px 45px;
    }
    th > div{
        max-width: 15rem;
        text-align: center;
        margin-right: auto;
        margin-left: auto;
    }
    td{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: #1E2245;
        background-color: #fdfcfc;
        padding: 13px 45px 13px 45px;
        letter-spacing: -0.34px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        max-width: 15rem;
    }

    td > div{
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        max-width: 15rem;
        margin-right: auto;
        margin-left: auto;
    }
    td > .loading{
        max-width: 100% !important;
    }
  
/*
    tr:nth-child(1n){

        border-bottom-style: solid; 
        border-bottom-width: 1px;
        border-bottom-color: #EFF1FB;
    
    }
    
    tr:hover{background-color: #FCFCFC}
    
    th {
    
        background-color: #f3f4f6;
        color:#96999A;
        font-weight: 500;
    }
*/
    
    /**Fin tabla kardex */
    tbody {
      display:block;
      max-height:60vh;
      min-width: 1000px;
      background-color: #fdfcfc;
    }
    tr {
      display:table;
      table-layout:fixed;
      width: 100%;
    }
    table.ck-table.modal  tbody {
      display:block;
      max-height:60vh;
      min-width: 700px;
      background-color: #fdfcfc;
    }

    .td-short td{
        padding-top:1px !important;
        padding-bottom:1px !important;
    }

    tbody > div {
        vertical-align: middle !important;
    }
    
</style>